import { render, staticRenderFns } from "./GameQuiz.vue?vue&type=template&id=57e3bdc3&"
import script from "./GameQuiz.vue?vue&type=script&lang=js&"
export * from "./GameQuiz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports